import React, { useState, useEffect, useMemo } from 'react';
import { db, auth } from '../firebase';
import {
    collection,
    getDocs,
    query,
    orderBy,
    doc,
    getDoc,
    writeBatch,
    increment,
    serverTimestamp
} from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { Map, AdvancedMarker, Pin, APIProvider } from '@vis.gl/react-google-maps';
import {
    FiChevronLeft,
    FiChevronRight,
    FiCalendar,
    FiMapPin,
    FiUser,
    FiX,
    FiCheck,
    FiPlus,
    FiMinus,
    FiUserCheck
} from 'react-icons/fi';

// --- FORDÍTÁSI TÁBLÁZAT ---
const translationMap = {
    'mini': 'Mini',
    'gyerek': 'Gyerek',
    'junior': 'Junior',
    'kadet': 'Kadét',
    'fiatal_felnott': 'Fiatal felnőtt',
    'felnott': 'Felnőtt',
    'szenior': 'Szenior',
    'veteran': 'Veterán',
    '3d_hdh_bb': 'BB (Barebow)',
    '3d_hdh_bg': 'BG (Fúvócső)',
    '3d_hdh_cb': 'CB (Csigás Barebow)',
    '3d_hdh_crb': 'CRB (Számszeríj)',
    '3d_hdh_cu': 'CU (Scope-os Csigás)',
    '3d_hdh_hu': 'HU (Vadász Csigás)',
    '3d_hdh_ol': 'OL (Olimpiai)',
    '3d_hdh_pbhb': 'PBHB (Tradi)',
    '3d_hdh_trlb': 'TRLB (Longbow)',
    '3d_hdh_trrb': 'TRRB (Vadászreflex)',
    '3d_ifaa_bbc': 'BB(C) (Barebow-Csigás)',
    '3d_ifaa_bbr': 'BB(R) (Barebow-Reflex)',
    '3d_ifaa_bhc': 'BH(C) (Vadászijász-Csigás)',
    '3d_ifaa_bhr': 'BH(R) (Vadászijász-Reflex)',
    '3d_ifaa_bl': 'BL (Korlátozott Vadászijász)',
    '3d_ifaa_bu': 'BU (Bowhunter Unlimited)',
    '3d_ifaa_fsc': 'FS(C) (Korl. nyílt o.-Csigás)',
    '3d_ifaa_fsr': 'FS(R) (Korl. nyílt o.-Reflex)',
    '3d_ifaa_fu': 'FU (Korlátlan nyílt osztály)',
    '3d_ifaa_hb': 'HB (Történelmi íj)',
    '3d_ifaa_hbm': 'HB(M) (Történelmi íj modern)',
    '3d_ifaa_lb': 'LB (Longbow)',
    '3d_ifaa_tr': 'TR (Tradicionális reflex)',
    'terep_olimpiai': 'OL (Olimpiai)',
    'terep_csigas': 'CU (Scope-os Csigás)',
    'terep_barebow': 'BB (Barebow)',
    'terep_cb': 'CB (Csigás Barebow)',
    'terep_hu': 'HU (Vadász Csigás)',
    'terep_pbhb': 'PBHB (Tradi - Pusztai íj)',
    'terep_trlb': 'TRLB (Longbow)',
    'terep_trrb': 'TRRB (Vadászreflex)',
    'palya_wa_ol': 'R (Olimpiai reflexíj)',
    'palya_wa_cu': 'CU (Scope-os Csigás)',
    'palya_wa_hu': 'HU (Vadász Csigás)',
    'palya_wa_bb': 'B (Barebow)',
    'palya_wa_trrb': 'TRRB (Vadászreflex)',
    'palya_wa_trlb': 'TRLB (Longbow)',
    'palya_wa_pbhb': 'PBHB (Tradi - Pusztai íj)',
    'palya_wa_crb': 'CRB (Számszeríj)',
    'palya_ifaa_fu': 'FU (Freestyle Unlimited)',
    'palya_ifaa_fsr': 'FSR (Freestyle Ltd Recurve)',
    'palya_ifaa_fsc': 'FSC (Freestyle Ltd Compound)',
    'palya_ifaa_bbr': 'BBR (Barebow Recurve)',
    'palya_ifaa_bbc': 'BBC (Barebow Compound)',
    'palya_ifaa_bu': 'BU (Bowhunter Unlimited)',
    'palya_ifaa_bl': 'BL (Bowhunter Limited)',
    'palya_ifaa_bhc': 'BHC (Bowhunter Compound)',
    'palya_ifaa_bhr': 'BHR (Bowhunter Recurve)',
    'palya_ifaa_lb': 'LB (Longbow)',
    'palya_ifaa_hb': 'HB (Historical Bow)',
    'palya_ifaa_tr': 'TR (Traditional Bow)',
    'tortenelmi_pusztai_modern': 'Modern pusztai íj',
    'tortenelmi_pusztai_termeszetes': 'Természetes pusztai íj',
    'tortenelmi_botij': 'Történelmi hosszúíj / Botíj',
    'tortenelmi_vadaszij': 'Hagyományos vadászíj',
    'tortenelmi_szamszerij': 'Történelmi számszeríj',
    'tortenelmi_bb': 'BB (Barebow - Vendég kategória)',
    'orom_wa_ol': 'OL (Olimpiai reflexíj)',
    'orom_wa_cu': 'CU (Scope-os Csigás)',
    'orom_wa_hu': 'HU (Vadász Csigás)',
    'orom_wa_cb': 'CB (Csigás Barebow)',
    'orom_wa_bb': 'BB (Barebow)',
    'orom_wa_trrb': 'TRRB (Vadászreflex)',
    'orom_wa_trlb': 'TRLB (Longbow)',
    'orom_wa_pbhb': 'PBHB (Pusztai íj)',
    'orom_wa_crb': 'CRB (Számszeríj)',
    'orom_wa_bg': 'BG (Fúvócső)',
    'egyeb_wa_ol': 'OL (Olimpiai reflexíj)',
    'egyeb_wa_cu': 'CU (Scope-os Csigás)',
    'egyeb_wa_hu': 'HU (Vadász Csigás)',
    'egyeb_wa_cb': 'CB (Csigás Barebow)',
    'egyeb_wa_bb': 'BB (Barebow)',
    'egyeb_wa_trrb': 'TRRB (Vadászreflex)',
    'egyeb_wa_trlb': 'TRLB (Longbow)',
    'egyeb_wa_pbhb': 'PBHB (Pusztai íj)',
    'egyeb_wa_crb': 'CRB (Számszeríj)',
    'egyeb_wa_bg': 'BG (Fúvócső)',
    'egyeb_altalanos': 'Egyéb Általános'
};

// --- ÚJ: KLUB NÉV FORMÁZÓ SEGÉDFÜGGVÉNY ---
const formatClubName = (name) => {
  if (!name || name === "Egyéb" || name === "N/A" || name === "Ismeretlen") return name;
  const specialCases = {
      "3d": "3D", "kft.": "Kft.", "se": "SE", "sk": "SK", "dse": "DSE",
      "kse": "KSE", "mavir": "MAVIR", "ifaa": "IFAA", "hdh-iaa": "HDH-IAA"
  };

  return name.split(' ').map(word => {
    const cleanWord = word.replace(/[^a-zA-ZáéíóöőúüűÁÉÍÓÖŐÚÜŰ0-9]/g, '').toLowerCase();
    if (specialCases[cleanWord]) return specialCases[cleanWord];
    if (word.startsWith('"')) {
        return '"' + (word.charAt(1)?.toUpperCase() || "") + word.slice(2).toLowerCase();
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(' ');
};

const pageContainerStyle = {
    padding: '2rem',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f0f2f5',
    minHeight: 'calc(100vh - 4rem)',
    maxWidth: '1200px',
    margin: '0 auto'
};

const headingStyle = {
    color: '#b30000',
    textAlign: 'center',
    marginBottom: '1.5rem'
};

const mapContainerStyle = {
    width: '100%',
    height: '350px',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    marginBottom: '2rem'
};

const weekNavigatorStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: '12px 20px',
    borderRadius: '10px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    marginBottom: '20px'
};

const navBtnStyle = {
    backgroundColor: '#b30000',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 12px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontWeight: 'bold',
    fontSize: '0.9rem',
    transition: 'background 0.2s'
};

const weekTextStyle = {
    fontSize: '1.1rem',
    fontWeight: 'bold',
    color: '#333'
};

const cardStyle = {
    display: 'flex',
    gap: '20px',
    border: '1px solid #ddd',
    borderRadius: '12px',
    padding: '16px',
    margin: '16px 0',
    boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
    backgroundColor: '#fff',
    minHeight: '120px',
};

const leftColumnStyle = {
    flex: '1 1 45%',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
};

const titleRowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center', 
    marginBottom: '4px',
    gap: '8px',
};

const rightColumnStyle = {
    flex: '1 1 55%',
    borderLeft: '1px solid #eee',
    paddingLeft: '20px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
};

const descriptionTitleStyle = {
    fontSize: '0.95em',
    color: '#555',
    fontWeight: 'bold',
    marginBottom: '4px',
    marginTop: '0',
};

const descriptionScrollableAreaStyle = {
    overflowY: 'auto',
    maxHeight: '90px',
    paddingRight: '5px',
};

const descriptionParagraphStyle = {
    fontSize: '0.85em',
    color: '#333',
    margin: '0',
    overflowWrap: 'break-word',
    wordBreak: 'normal'
}

const titleStyle = {
    color: '#b30000',
    marginTop: '0',
    marginBottom: '0',
    fontSize: '1.15rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexGrow: 1,
};

const detailStyle = {
    fontSize: '0.85em',
    color: '#444',
    margin: '0',
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
};

const registrationButtonStyle = {
    backgroundColor: '#b30000',
    color: 'white',
    padding: '6px 12px',
    borderRadius: '6px',
    textDecoration: 'none',
    fontWeight: 'bold',
    fontSize: '0.8em',
    border: 'none',
    cursor: 'pointer',
    flexShrink: 0,
};

const registrationButtonDisabledStyle = {
    ...registrationButtonStyle,
    backgroundColor: '#eeeeee', // JAVÍTÁS: Világosabb szürke
    color: '#000000', // JAVÍTÁS: Fekete betűk
    cursor: 'not-allowed',
};

// --- MODAL STÍLUSOK ---
const modalOverlayStyle = {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center',
    alignItems: 'center', zIndex: 1000, backdropFilter: 'blur(3px)'
};

const modalContentStyle = {
    backgroundColor: '#fff', width: '90%', maxWidth: '450px', borderRadius: '15px',
    boxShadow: '0 15px 35px rgba(0,0,0,0.3)', overflow: 'hidden'
};

const modalHeaderStyle = {
    backgroundColor: '#b30000', color: '#fff', padding: '15px 20px',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center'
};

const modalBodyStyle = { padding: '20px' };

const profileRegCardStyle = {
    backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '10px',
    border: '1px solid #eee', marginBottom: '15px'
};

const genderToggleStyle = {
    backgroundColor: '#b30000', color: '#fff', border: 'none', padding: '6px 12px',
    borderRadius: '8px', fontWeight: 'bold', fontSize: '0.85rem', cursor: 'pointer',
    display: 'flex', alignItems: 'center', gap: '5px'
};

const inputGroupStyle = { marginBottom: '15px', display: 'flex', flexDirection: 'column', gap: '5px' };

const regLabelStyle = { fontSize: '0.75rem', fontWeight: 'bold', color: '#b30000', textTransform: 'uppercase' };

const regSelectStyle = {
    padding: '10px', borderRadius: '8px', border: '1px solid #ddd',
    backgroundColor: '#fff', fontSize: '0.9rem'
};

const regTextAreaStyle = {
    ...regSelectStyle, minHeight: '80px', resize: 'vertical'
};

const lunchCounterStyle = {
    display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: '#f8f9fa',
    padding: '5px', borderRadius: '8px', border: '1px solid #ddd', width: 'fit-content'
};

const lunchBtnStyle = {
    backgroundColor: '#fff', color: '#b30000', border: '1px solid #ddd',
    width: '32px', height: '32px', borderRadius: '6px', cursor: 'pointer',
    display: 'flex', justifyContent: 'center', alignItems: 'center'
};

const regSubmitButtonStyle = {
    width: '100%', backgroundColor: '#b30000', color: '#fff', border: 'none',
    padding: '14px', borderRadius: '10px', fontWeight: 'bold', fontSize: '1rem',
    cursor: 'pointer', marginTop: '10px', boxShadow: '0 4px 6px rgba(179,0,0,0.2)'
};

// --- ÚJ SEGÉDFÜGGVÉNY A TÍPUSOK MEGJELENÍTÉSÉHEZ ---
const getCompetitionTypeDisplay = (rawType) => {
    const type = rawType?.toLowerCase() || '';
    if (type.includes('3d')) return { label: '3D', color: '#28a745' };
    if (type.includes('palya') || type.includes('pálya')) return { label: 'Pálya', color: '#007bff' };
    if (type.includes('orom') || type.includes('öröm')) return { label: 'Örömijász', color: '#ffc107' };
    if (type.includes('tortenelmi') || type.includes('történelmi')) return { label: 'Történelmi', color: '#dc3545' };
    if (type.includes('terep')) return { label: 'Terep', color: '#6d4c41' };
    if (type.includes('egyeb') || type.includes('egyéb')) return { label: 'Egyéb', color: '#9c27b0' };
    return { label: rawType || 'Egyéb', color: '#9c27b0' };
};

const EventsListPage = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentUser, setCurrentUser] = useState(null);
    const [isCompetitor, setIsCompetitor] = useState(false);
    const [userProfile, setUserProfile] = useState(null);
    const [joinedEvents, setJoinedEvents] = useState(new Set());
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // --- MODAL ÁLLAPOTOK ---
    const [showRegModal, setShowRegModal] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [registrationSuccess, setRegistrationSuccess] = useState(false);
    const [regData, setRegData] = useState({
        gender: 'Férfi',
        bowCategory: '',
        ageCategory: '',
        lunchCount: 0,
        comment: ''
    });

    const [currentWeekStart, setCurrentWeekStart] = useState(() => {
        // Megpróbáljuk visszatölteni az előzőleg nézett hetet a munkamenetből
        const savedWeek = sessionStorage.getItem('last_viewed_competition_week');
        if (savedWeek) {
            return new Date(savedWeek);
        }

        const d = new Date();
        const day = d.getDay();
        const diff = d.getDate() - day + (day === 0 ? -6 : 1);
        return new Date(d.setDate(diff));
    });

    // Minden hétváltáskor elmentjük az új kezdődátumot
    useEffect(() => {
        sessionStorage.setItem('last_viewed_competition_week', currentWeekStart.toISOString());
    }, [currentWeekStart]);

    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);

        const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
            setCurrentUser(user);
// ...
            if (user) {
                try {
                    const userDocRef = doc(db, "users", user.uid);
                    const userDocSnap = await getDoc(userDocRef);
                    if (userDocSnap.exists()) {
                        setIsCompetitor(true);
                        const profile = userDocSnap.data();
                        setUserProfile(profile);
                        setRegData(prev => ({ ...prev, gender: profile.gender || 'Férfi' }));
                    } else {
                        setIsCompetitor(false);
                    }
                } catch (err) {
                    console.error("Hiba a felhasználói adatok lekérésekor:", err);
                    setIsCompetitor(false);
                }
            } else {
                setIsCompetitor(false);
                setUserProfile(null);
                setJoinedEvents(new Set());
            }
        });

        const fetchEvents = async () => {
            setLoading(true);
            setError(null);
            try {
                const eventsCollectionRef = collection(db, "events");
                const q = query(eventsCollectionRef, orderBy("createdAt", "desc"));
                const querySnapshot = await getDocs(q);
                const eventsData = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                console.log("📍 Letöltött versenyek a térképhez:", eventsData);
                setEvents(eventsData);

                // --- HA VAN FELHASZNÁLÓ, ELLENŐRIZZÜK A NEVEZÉSEKET ---
                if (auth.currentUser) {
                    const joinedSet = new Set();
                    for (const event of eventsData) {
                        const partRef = doc(db, "events", event.id, "participants", auth.currentUser.uid);
                        const partSnap = await getDoc(partRef);
                        if (partSnap.exists()) {
                            joinedSet.add(event.id);
                        }
                    }
                    setJoinedEvents(joinedSet);
                }

            } catch (err) {
                console.error("Hiba az események lekérdezése közben:", err);
                setError("Hiba történt az események betöltése közben.");
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
        return () => {
            unsubscribeAuth();
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const changeWeek = (direction) => {
        setCurrentWeekStart(prev => {
            const newDate = new Date(prev);
            newDate.setDate(newDate.getDate() + (direction * 7));
            return newDate;
        });
    };

    const weekDisplayString = useMemo(() => {
        const start = new Date(currentWeekStart);
        const end = new Date(currentWeekStart);
        end.setDate(end.getDate() + 6);

        const options = { year: 'numeric', month: 'short', day: 'numeric', weekday: 'long' };
        return `${start.toLocaleDateString('hu-HU', options)} - ${end.toLocaleDateString('hu-HU', options)}`;
    }, [currentWeekStart]);

    const filteredEvents = useMemo(() => {
        const weekStartMs = new Date(currentWeekStart).setHours(0,0,0,0);
        const weekEndMs = new Date(currentWeekStart);
        weekEndMs.setDate(weekEndMs.getDate() + 6);
        weekEndMs.setHours(23,59,59,999);

        return events.filter(event => {
            // SZŰRÉS: Ne jelenítsük meg a lezárt versenyeket
            if (event.status === 'Lezárt') return false;

            const eventDateStr = event.competitionDate || event.startDate;
            if (!eventDateStr) return false;
            const eventTime = new Date(eventDateStr).getTime();
            return eventTime >= weekStartMs && eventTime <= weekEndMs;
        });
    }, [events, currentWeekStart]);

    const handleRegistrationNavigation = (event) => {
        if (currentUser && isCompetitor) {
            setSelectedEvent(event);
            setRegistrationSuccess(false); // Reset siker állapot
            setRegData(prev => ({
                ...prev,
                bowCategory: '',
                ageCategory: '',
                lunchCount: 0,
                comment: ''
            }));
            setShowRegModal(true);
        } else if (!currentUser) {
            alert("A nevezéshez kérjük, jelentkezzen be!");
        }
    };

    const handleJoinSubmit = async () => {
        if (!regData.bowCategory || !regData.ageCategory) {
            alert("Kérjük, válassz kategóriát és korosztályt!");
            return;
        }

        setIsSubmitting(true);
        try {
            const batch = writeBatch(db);
            const participantRef = doc(db, "events", selectedEvent.id, "participants", currentUser.uid);

            const registrationData = {
                userId: currentUser.uid,
                lastName: userProfile?.lastName || '',
                firstName: userProfile?.firstName || '',
                fullName: `${userProfile?.lastName || ''} ${userProfile?.firstName || ''}`.trim(),
                club: userProfile?.clubName || userProfile?.club || '',
                gender: regData.gender,
                birthDate: userProfile?.birthDate || 0,
                bowCategory: regData.bowCategory,
                ageCategory: regData.ageCategory,
                entryFee: selectedEvent.ageFees?.[regData.ageCategory] || '', // Nevezési díj hozzáadása a korosztály alapján
                lunchCount: regData.lunchCount,
                comment: regData.comment,
                registrationDate: serverTimestamp(),
                status: "Nevezve",
                registeredVia: "web"
            };

            batch.set(participantRef, registrationData);

            const eventRef = doc(db, "events", selectedEvent.id);
            batch.update(eventRef, {
                participantsCount: increment(1)
            });

            await batch.commit();

            // Frissítjük a helyi listát
            setJoinedEvents(prev => new Set(prev).add(selectedEvent.id));
            setRegistrationSuccess(true); // Mutatjuk a sikert az ablakban

            // 2 másodperc múlva bezárjuk
            setTimeout(() => {
                setShowRegModal(false);
                setRegistrationSuccess(false);
            }, 2000);

        } catch (err) {
            console.error("Hiba a nevezés mentésekor:", err);
            alert("Hiba történt a mentés során.");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (loading && currentUser === undefined) {
        return <div style={pageContainerStyle}><p style={{textAlign: 'center'}}>Betöltés...</p></div>;
    }

    if (error) {
        return <div style={pageContainerStyle}><p style={{textAlign: 'center', color: 'red'}}>{error}</p></div>;
    }

    return (
        <div className="force-light-theme" style={{ ...pageContainerStyle, padding: isMobile ? '1rem' : '2rem' }}>
            {/* --- KOMPAKT STÍLUSOK A KÁRTYÁN BELÜLI HTML-HEZ --- */}
            <style>{`
                .card-description-container h1,
                .card-description-container h2,
                .card-description-container h3 {
                    font-size: 1rem !important;
                    margin: 5px 0 !important;
                }
                .card-description-container * {
                    overflow-wrap: break-word !important;
                    word-break: normal !important;
                    hyphens: none !important;
                }
            `}</style>

            {/* --- NEVEZÉSI MODAL (ARCHERY NEXUS STÍLUS) --- */}
            {/* ... [modal content omitted for brevity, keeping it unchanged] ... */}
            {showRegModal && selectedEvent && (
                <div style={modalOverlayStyle}>
                    <div style={modalContentStyle}>
                        <div style={modalHeaderStyle}>
                            <h3>Nevezés a versenyre</h3>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    backgroundColor: '#f2f2f2',
                                    borderRadius: '50%',
                                    width: '32px',
                                    height: '32px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                                onClick={() => setShowRegModal(false)}
                            >
                                <FiX size={20} color="#333" />
                            </div>
                        </div>

                        <div style={modalBodyStyle}>
                            {registrationSuccess ? (
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '40px 0',
                                    gap: '15px'
                                }}>
                                    <div style={{
                                        width: '80px',
                                        height: '80px',
                                        backgroundColor: '#e6fffa',
                                        color: '#28a745',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '2.5rem',
                                        boxShadow: '0 4px 10px rgba(40, 167, 69, 0.2)'
                                    }}>
                                        <FiCheck />
                                    </div>
                                    <h2 style={{ color: '#28a745', margin: 0 }}>Sikeres nevezés!</h2>
                                    <p style={{ color: '#666', fontSize: '0.9rem' }}>Sok sikert a versenyen!</p>
                                </div>
                            ) : (
                                <>
                                    <p style={{ textAlign: 'center', color: '#666', fontSize: '0.85rem', marginBottom: '20px' }}>
                                        Kérjük, ellenőrizze adatait
                                    </p>

                                    {/* PROFIL KÁRTYA */}
                                    <div style={profileRegCardStyle}>
                                        <div style={{ display: 'flex', gap: '5px', fontSize: '0.9rem', marginBottom: '5px' }}>
                                            <strong>NÉV:</strong>
                                            <span>{userProfile?.lastName} {userProfile?.firstName}</span>
                                        </div>
                                        <div style={{ fontSize: '0.85rem', color: '#666', marginBottom: '10px' }}>
                                            {userProfile?.clubName || userProfile?.club || 'Nincs egyesület'}
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <button
                                                style={genderToggleStyle}
                                                onClick={() => setRegData(prev => ({ ...prev, gender: prev.gender === 'Férfi' ? 'Nő' : 'Férfi' }))}
                                            >
                                                {regData.gender === 'Férfi' ? 'Férfi' : 'Nő'} <FiChevronRight />
                                            </button>
                                            <div style={{ textAlign: 'right' }}>
                                                <div style={{ fontSize: '0.7rem', fontWeight: 'bold', color: '#888' }}>SZÜLETÉSI DÁTUM</div>
                                                <div style={{ fontSize: '0.9rem' }}>
                                                    {userProfile?.birthDate ? new Date(userProfile.birthDate).toLocaleDateString('hu-HU') : '-'}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr style={{ border: 'none', borderTop: '1px solid #eee', margin: '20px 0' }} />

                                    {/* ÍJKATEGÓRIA VÁLASZTÓ */}
                                    <div style={inputGroupStyle}>
                                        <label style={regLabelStyle}>Válassz íjkategóriát</label>
                                        <select
                                            style={regSelectStyle}
                                            value={regData.bowCategory}
                                            onChange={(e) => setRegData(prev => ({ ...prev, bowCategory: e.target.value }))}
                                        >
                                            <option value="">Válassz kategóriát...</option>
                                            {selectedEvent.categories?.map(cat => (
                                                <option key={cat} value={cat}>{translationMap[cat] || cat}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* KOROSZTÁLY VÁLASZTÓ */}
                                    <div style={inputGroupStyle}>
                                        <label style={regLabelStyle}>Válassz korosztályt</label>
                                        <select
                                            style={regSelectStyle}
                                            value={regData.ageCategory}
                                            onChange={(e) => setRegData(prev => ({ ...prev, ageCategory: e.target.value }))}
                                        >
                                            <option value="">Válassz korosztályt...</option>
                                            {selectedEvent.ageCategories?.map(age => (
                                                <option key={age} value={age}>{translationMap[age] || age}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* EBÉD (HA ELÉRHETŐ) */}
                                    {selectedEvent.lunchAvailable && (
                                        <div style={inputGroupStyle}>
                                            <label style={regLabelStyle}>Ebéd igény (adag):</label>
                                            <div style={lunchCounterStyle}>
                                                <button
                                                    style={lunchBtnStyle}
                                                    onClick={() => setRegData(prev => ({ ...prev, lunchCount: Math.max(0, prev.lunchCount - 1) }))}
                                                >
                                                    <FiMinus />
                                                </button>
                                                <span style={{ width: '40px', textAlign: 'center', fontWeight: 'bold' }}>{regData.lunchCount}</span>
                                                <button
                                                    style={lunchBtnStyle}
                                                    onClick={() => setRegData(prev => ({ ...prev, lunchCount: prev.lunchCount + 1 }))}
                                                >
                                                    <FiPlus />
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    {/* MEGJEGYZÉS */}
                                    <div style={inputGroupStyle}>
                                        <label style={regLabelStyle}>Megjegyzés a szervezőnek:</label>
                                        <textarea
                                            style={regTextAreaStyle}
                                            placeholder="Pl. csapattárs kérés..."
                                            value={regData.comment}
                                            onChange={(e) => setRegData(prev => ({ ...prev, comment: e.target.value }))}
                                        />
                                    </div>

                                    <button
                                        style={regSubmitButtonStyle}
                                        onClick={handleJoinSubmit}
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? 'Mentés...' : 'Nevezés beküldése'}
                                    </button>

                                    <p style={{ fontSize: '0.65rem', color: '#888', textAlign: 'center', marginTop: '15px', lineHeight: '1.4' }}>
                                        *A "Nevezés beküldése" gombra kattintva kijelented, hogy elolvastad és elfogadtad a versenyszabályzatot!
                                    </p>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {!isMobile && <h1 style={{ ...headingStyle, fontSize: '2.5rem' }}>Aktuális Versenyek</h1>}

            {/* FELSŐ TÉRKÉP SZEKCIÓ */}
            <div style={{ ...mapContainerStyle, height: isMobile ? '250px' : '350px' }}>
                <Map
                    defaultCenter={{ lat: 47.1625, lng: 19.5033 }}
                    defaultZoom={7}
                    mapId="DEMO_MAP_ID"
                    style={{ width: '100%', height: '100%' }}
                    disableDefaultUI={true}
                    gestureHandling={'greedy'}
                >
                    {filteredEvents.map(event => {
                        const lat = parseFloat(event.gpsLatitude);
                        const lng = parseFloat(event.gpsLongitude);

                        if (!isNaN(lat) && !isNaN(lng)) {
                            const typeDisplay = getCompetitionTypeDisplay(event.competitionType);

                            return (
                                <AdvancedMarker 
                                    key={event.id} 
                                    position={{ lat, lng }}
                                    title={event.competitionName}
                                >
                                    <div style={{
                                        width: '18px',
                                        height: '18px',
                                        backgroundColor: typeDisplay.color,
                                        borderRadius: '50%',
                                        border: '3px solid white',
                                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                                        transform: 'translate(-50%, -50%)',
                                        cursor: 'pointer'
                                    }} />
                                </AdvancedMarker>
                            );
                        }
                        return null;
                    })}
                </Map>
            </div>

            {/* HETI NAVIGÁTOR */}
            <div style={{ ...weekNavigatorStyle, padding: isMobile ? '10px' : '12px 20px' }}>
                <button style={navBtnStyle} onClick={() => changeWeek(-1)}>
                    <FiChevronLeft size={isMobile ? 24 : 18} /> { !isMobile && "Előző hét" }
                </button>
                <span style={{ ...weekTextStyle, fontSize: isMobile ? '0.9rem' : '1.1rem' }}>
                    { !isMobile && <FiCalendar style={{ verticalAlign: 'middle', marginRight: '6px' }} /> }
                    {weekDisplayString}
                </span>
                <button style={navBtnStyle} onClick={() => changeWeek(1)}>
                    { !isMobile && "Következő hét" } <FiChevronRight size={isMobile ? 24 : 18} />
                </button>
            </div>

            {/* VERSENYEK LISTÁJA */}
            {filteredEvents.length === 0 && !loading && (
                <div style={{ textAlign: 'center', padding: '40px', color: '#666', background: '#fff', borderRadius: '10px' }}>
                    <p>Erre a hétre nincsenek meghirdetett versenyek.</p>
                </div>
            )}

            {filteredEvents.map(event => {
                const isJoined = joinedEvents.has(event.id);
                const typeDisplay = getCompetitionTypeDisplay(event.competitionType);

                // --- NEVEZÉSI HATÁRIDŐ ELLENŐRZÉSE ---
                const isDeadlinePassed = (() => {
                    if (!event.registrationDeadline) return false;
                    const deadline = new Date(event.registrationDeadline);
                    deadline.setHours(23, 59, 59, 999);
                    return new Date() > deadline;
                })();

                if (isMobile) {
                    // --- MOBIL NÉZET (item_competition.xml stílus) ---
                    return (
                        <div
                            key={event.id}
                            style={{
                                backgroundColor: '#fff',
                                borderRadius: '12dp',
                                padding: '16px',
                                margin: '8px 0',
                                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                position: 'relative',
                                display: 'flex',
                                flexDirection: 'column',
                                cursor: 'pointer'
                            }}
                            onClick={() => navigate(`/verseny/${event.id}`)}
                        >
                            {/* NEVEZVE JELZŐ IKON - ELTÁVOLÍTVA FENTRŐL */}

                            {/* ÚJ: KLUB LOGÓ (Jobb felső sarok) */}
                            {event.organizingClubLogoUrl && (
                                <div style={{
                                    position: 'absolute', top: '12px', right: '12px',
                                    width: '36px', height: '36px', borderRadius: '50%',
                                    border: '2px solid white', boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                    overflow: 'hidden', backgroundColor: '#fff'
                                }}>
                                    <img src={event.organizingClubLogoUrl} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                </div>
                            )}

                            {/* CÍM ÉS TÍPUS */}
                            <h2 style={{ color: '#D32F2F', fontSize: '1.25rem', fontWeight: 'bold', margin: '0', paddingRight: '45px' }}>
                                {event.competitionName}
                            </h2>
                            <div style={{ color: typeDisplay.color, fontSize: '0.75rem', fontWeight: 'bold', marginTop: '2px' }}>
                                {typeDisplay.label}
                            </div>

                            {/* SZERVEZŐ ÉS NEVEZŐK */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '4px' }}>
                                <div style={{ color: '#666', fontSize: '0.85rem', opacity: 0.8 }}>
                                    Szervező: {formatClubName(event.organizingClub) || 'N/A'}
                                </div>
                                <div style={{ color: '#b30000', fontSize: '0.85rem', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <FiUserCheck size={14} /> {event.participantsCount || 0} / {event.maxParticipants || 999}
                                </div>
                            </div>

                            {/* ELVÁLASZTÓ VONAL */}
                            <div style={{ height: '1px', backgroundColor: '#eee', margin: '12px 0', opacity: 0.5 }} />

                            {/* ALSÓ SOR: DÁTUM + NAP + HELYSZÍN + NEVEZVE PIPI */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', alignItems: 'center', fontSize: '0.85rem' }}>
                                    <span style={{ fontStyle: 'italic', color: '#444' }}>
                                        {event.competitionDate ? new Date(event.competitionDate).toLocaleDateString('hu-HU', { year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'long' }) : 'Folyamatos'}
                                    </span>
                                    <span style={{ fontWeight: 'bold', color: '#D32F2F' }}>
                                        {event.location ? event.location.split(',')[0].trim() : 'N/A'}
                                    </span>
                                </div>

                                {/* NEVEZVE JELZŐ (Ide költöztetve) */}
                                {isJoined && (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#28a745', fontWeight: 'bold', fontSize: '0.75rem' }}>
                                        <FiUserCheck size={16} />
                                        <span>NEVEZVE</span>
                                    </div>
                                )}
                            </div>

                            {/* NEVEZÉS GOMB (HA MÉG NEM NEVEZETT ÉS AKTÍV A NEVEZÉS) */}
                            {!isJoined && isCompetitor && (
                                event.creationType === 'announcement' ? (
                                    <button
                                        style={{
                                            ...registrationButtonDisabledStyle,
                                            marginTop: '12px',
                                            padding: '10px',
                                            fontSize: '0.9rem',
                                            width: '100%',
                                            opacity: 1
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        A NEVEZÉS MÉG ZÁRVA
                                    </button>
                                ) : !isDeadlinePassed && (
                                    <button
                                        style={{
                                            marginTop: '12px',
                                            backgroundColor: '#b30000',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '8px',
                                            padding: '10px',
                                            fontWeight: 'bold',
                                            fontSize: '0.9rem'
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleRegistrationNavigation(event);
                                        }}
                                    >
                                        NEVEZÉS
                                    </button>
                                )
                            )}
                        </div>
                    );
                }

                // --- ASZTALI NÉZET ---
                return (
                    <div
                        key={event.id}
                        style={{ ...cardStyle, cursor: 'pointer', position: 'relative' }}
                        onClick={() => navigate(`/verseny/${event.id}`)}
                    >
                        {/* ÚJ: KLUB LOGÓ (Jobb felső sarok) */}
                        {event.organizingClubLogoUrl && (
                            <div style={{
                                position: 'absolute', top: '20px', right: '55.5%', // A bal oszlop szélére igazítva
                                width: '40px', height: '40px', borderRadius: '50%',
                                border: '2px solid white', boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                                overflow: 'hidden', backgroundColor: '#fff', zIndex: 2
                            }}>
                                <img src={event.organizingClubLogoUrl} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            </div>
                        )}

                        <div style={leftColumnStyle}>
                            <div style={titleRowStyle}>
                                <h2 style={{ ...titleStyle, paddingRight: '45px' }} title={event.competitionName || ''}>
                                    {event.competitionName || 'Nincs név megadva'}
                                </h2>

                                {isCompetitor && (
                                    event.creationType === 'announcement' ? (
                                        <button
                                            style={{ ...registrationButtonDisabledStyle, opacity: 1, backgroundColor: '#eeeeee', cursor: 'default', whiteSpace: 'nowrap', marginRight: '45px' }}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            A NEVEZÉS MÉG ZÁRVA
                                        </button>
                                    ) : isDeadlinePassed ? (
                                        <button
                                            style={{ ...registrationButtonDisabledStyle, opacity: 1, backgroundColor: '#eeeeee', cursor: 'default', marginRight: '45px' }}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            Nevezés lezárult
                                        </button>
                                    ) : (
                                        <button
                                            style={{ ...registrationButtonStyle, marginRight: '45px' }}
                                            onMouseEnter={(e) => e.target.style.backgroundColor = '#900000'}
                                            onMouseLeave={(e) => {
                                                if (e.target) e.target.style.backgroundColor = '#b30000';
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleRegistrationNavigation(event);
                                            }}
                                        >
                                            Nevezés
                                        </button>
                                    )
                                )}
                            </div>

                        <p style={detailStyle}>
                            <strong>Típus:</strong>
                            <span style={{ color: typeDisplay.color, marginLeft: '5px', fontWeight: 'bold' }}>
                                {typeDisplay.label}
                            </span>
                        </p>

                        <p style={detailStyle}><FiUser size={14} color="#666" /> Szervező: {formatClubName(event.organizingClub) || 'N/A'}</p>
                        <p style={{ ...detailStyle, color: '#b30000', fontWeight: 'bold' }}>
                            <FiUserCheck size={14} /> Nevezők: {event.participantsCount || 0} / {event.maxParticipants || 999}
                        </p>

                        {/* ALSÓ SOR: DÁTUM + HELYSZÍN + NEVEZVE PIPÁCSKA */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 'auto', paddingTop: '10px' }}>
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', fontSize: '0.85rem' }}>
                                <span style={{ fontStyle: 'italic', color: '#444' }}>
                                    <FiCalendar size={14} style={{ marginRight: '4px', verticalAlign: 'middle' }} />
                                    {event.competitionDate ? new Date(event.competitionDate).toLocaleDateString('hu-HU', { year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'long' }) : 'Folyamatos'}
                                </span>
                                <span style={{ fontWeight: 'bold', color: '#D32F2F' }}>
                                    <FiMapPin size={14} style={{ marginRight: '4px', verticalAlign: 'middle' }} />
                                    {event.location}
                                </span>
                            </div>

                            {isJoined && (
                                <div
                                    style={{ display: 'flex', alignItems: 'center', gap: '5px', color: '#28a745', fontWeight: 'bold', fontSize: '0.8rem' }}
                                    title="Sikeresen neveztél erre a versenyre!"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <div style={{ position: 'relative', width: '32px', height: '32px' }}>
                                        <FiUserCheck size={32} />
                                        <div style={{ position: 'absolute', top: -2, right: -2, backgroundColor: '#b30000', color: 'white', borderRadius: '50%', width: '14px', height: '14px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px' }}>
                                            ✓
                                        </div>
                                    </div>
                                    <span>NEVEZVE</span>
                                </div>
                            )}
                        </div>
                    </div>

                    <div style={rightColumnStyle}>
                        <h3 style={descriptionTitleStyle}>Verseny leírása</h3>
                        <div style={descriptionScrollableAreaStyle} className="card-description-container">
                            <div
                                style={descriptionParagraphStyle}
                                dangerouslySetInnerHTML={{ __html: event.competitionDescription || 'Nincs megadva leírás.' }}
                            />
                        </div>
                    </div>
                </div>
            );
        })}
        </div>
    );
};

export default EventsListPage;


